"use client";
import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  IconButton,
  TextField,
  Typography,
  Paper,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";
import MicIcon from "@mui/icons-material/Mic";
import SendIcon from "@mui/icons-material/Send";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
const Chatbot: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState<
    {
      sender: string;
      text?: string;
      audioUrl?: string;
      option?: string[];
      Link?: string;
      cleanedTextArray?: string[];
    }[]
  >([]);
  const [inputValue, setInputValue] = useState(" ");
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const [mode, setMode] = useState("");
  const [client, setclient] = useState("");
  //   const client_id = useSelector((state: any) => state.client_id.client_id);
  //   console.log("client_id kkkk", client_id);
  const [uuid, setUuid] = useState<string>("");

  const handleToggle = () => {
    setOpen((prevOpen) => {
      const newOpen = !prevOpen;

      if (newOpen) {
        generateUUID(); // Call generateUUID if open is true
      } else {
        setMessages([]); // Clear messages if open is false
      }

      return newOpen; // Toggle the state
    });
  };

  useEffect(() => {
    if (open === true) {
      console.log("hi");
      handleSend("hi");
    }
  }, [uuid]);

  const handleStartRecording = async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          setAudioBlob(event.data);
        }
      };

      mediaRecorder.start();
      setIsRecording(true);
    }
  };
  useEffect(() => {
    if (audioBlob) {
      const audioUrl = URL.createObjectURL(audioBlob);
      // setMessages((prev) => [...prev, { sender: "You", audioUrl }]);
      convertToBase64AndSend(audioBlob);
    }
  }, [audioBlob]);
  const handleStopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.onstop = () => {
        setIsRecording(false);
      };
    }
  };

  const convertToBase64AndSend = async (blob: Blob) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result?.toString().split(",")[1];
      if (base64String) {
        setMessages((prev) => [...prev, { sender: "You", audioUrl:base64String }]);
        sendAudioToBackend(base64String);
      }
    };
    reader.readAsDataURL(blob);
  };

  const handleSend = async (option?: string) => {
    if (inputValue || option) {
      setMessages((prev) => [
        ...prev,
        { sender: "You", text: option ? option : inputValue },
      ]);
      const data = {
        workflow_name: "chatbot",
        text: option ? option : inputValue, // Sending the text message
        client_id: "4",
        public_id: uuid,
        lang: "en",
        channel: "default",
      };
      setInputValue("");
      try {
        const response = await axios.post(
          "https://dev.assisto.tech/workflow_apis/execute_workflow",
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("response", response);

        if (response) {
          const { Link, cleanedTextArray } = extractLink(
            response.data.executors_New_DM_output_message
          );
          console.log("Link", Link, cleanedTextArray);
          let cleanedText = "";
          if (Array.isArray(cleanedTextArray)) {
            cleanedText = "";
          } else {
            cleanedText = cleanedTextArray;
          }
          setMessages((prev) => [
            ...prev,
            {
              sender: "Bot",
              text: cleanedText,
              option: response.data.executors_New_DM_output_options, // Assuming this is the options array from the response
              Link: Link ?? "", // Change here for option 2
              cleanedTextArray: cleanedTextArray,
            },
          ]);
        } else {
          console.error("Error sending message to backend");
          setMessages((prev) => [
            ...prev,
            { sender: "Bot", text: "Sorry, something went wrong." },
          ]);
        }
      } catch (error) {
        console.error("Error:", error);
        setMessages((prev) => [
          ...prev,
          { sender: "Bot", text: "Sorry, something went wrong." },
        ]);
      }
    }
  };

  const extractLink = (text: string) => {
    console.log("text", text);

    const urlPattern = /(https?:\/\/[^\s]+)/g; // Regex pattern for URLs
    const matches = text.match(urlPattern); // Find matches in the text

    let Link: string | null = null;
    let cleanedTextArray: string[] = [];

    if (matches) {
      console.log("matches", matches);

      // Find the first link that contains "complaint" or "wa.me"
      Link = matches.find((url) => url.includes("complaint")) || null;

      if (Link) {
        // Remove the extracted link from the original text
        const cleanedText = text.replace(Link, "").trim(); // Remove the link and trim spaces

        // Split the cleaned text by '\n'
        cleanedTextArray = cleanedText.split("\n").map((line) => line.trim()); // Split by new line and trim each line

        console.log("cleanedTextArray", cleanedTextArray);
      }
    }

    // If no relevant link is found, just split the original text by '\n'
    if (!Link) {
      cleanedTextArray = text.split("\n").map((line) => line.trim());
    }

    // Return the extracted link and the cleaned text array
    return { Link, cleanedTextArray };
  };

  // Example usage

  const sendAudioToBackend = async (base64String: string) => {
    console.log("message", messages);
    try {
      const data = {
        audio: base64String,
        client_id: "4",
        public_id: uuid,
        workflow_name: "voicebot",
        channel: "voice",
      };
      //   const response = await audioPost(data);
      console.log("data audio",data)
      const response = await axios.post(
        "https://dev.assisto.tech/workflow_apis/execute_workflow",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.executors_TTS_output_audio) {
        const { Link, cleanedTextArray } = extractLink(
          response.data.executors_New_DM_Audio_output_message
        );
        console.log("Link", Link, cleanedTextArray);
        let cleanedText = "";
        if (Array.isArray(cleanedTextArray)) {
          cleanedText = "";
        } else {
          cleanedText = cleanedTextArray;
        }
        console.log("Audio sent successfully");
        setMessages((prev) => [
          ...prev,
          {
            sender: "Bot",
            text: cleanedText,
            audioUrl: response.data.executors_TTS_output_audio,
            option: response.data.executors_New_DM_output_options,
            Link: Link ?? "", // Change here for option 2
            cleanedTextArray: cleanedTextArray,
          },
        ]);
        
      } else {
        console.error("Error sending audio to backend");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Auto scroll to bottom when messages are updated
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const generateUUID = () => {
    const newUuid = uuidv4(); // Generate a random UUID
    setUuid(newUuid); // Update the state with the new UUID
    console.log("uuid", uuid);
    // handleSend("hi");
  };
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 1000,
        borderRadius: 2,
      }}
    >
      <IconButton
        onClick={handleToggle}
        sx={{
          backgroundColor: "#243B7F",
          color: "white",
          width: 56,
          height: 56,
          borderRadius: "50%",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          // "&:hover": { backgroundColor: "#10439F" },
          position: "relative",
          zIndex: open ? 1010 : 1000,
        }}
      >
        {open ? <CloseIcon /> : <ChatIcon />}
      </IconButton>
      {open && (
        <Paper
          elevation={6}
          sx={{
            position: "absolute",
            bottom: isMobile ? 70 : 70,
            right: 0,
            width: isMobile ? "90vw" : 420,
            height: isMobile ? "60vh" : 509,
            display: "flex",
            flexDirection: "column",
            borderRadius: "8px",
            boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.3)",
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // bgcolor: "#DDE3E9",
              bgcolor: "#F5F5F5",
              // p: 1,
              color: "white",
              borderRadius: "8px 8px 0 0",
              boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
              // borderBottom: "4px solid #ECECEC", // Add border bottom color here
            }}
          >
            <img
              src="/eastmanLogo.jpg"
              alt="Chatbot Icon"
              width={500}
              height={250}
              style={{ width: "35%", height: "auto" }} // Adjust the width to 60% and auto height
            />
          </Box> */}

          <Box
            sx={{
              flex: "1 1 auto",
              p: 2,
              overflowY: "auto",
              backgroundColor: "white",
              // background: `linear-gradient(to right, #e65e13, #e97116, #eb821d, #ed9226, #efa232)`,
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#243B7F",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#F5F5F5",
              },
            }}
          >
            {messages.map((msg, index) => {
              if (index === 0) {
                return null; // Skip rendering for index 0
              }

              return (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems:
                      msg.sender === "You" ? "flex-end" : "flex-start",
                    mb: 1,
                  }}
                >
                  {msg.audioUrl ? (
                    msg.sender === "You" ? (
                      <Box
                        component="audio"
                        controls
                        sx={{
                          border: `2px solid ${
                            msg.sender === "You" ? "#243B7F" : "#D85C26"
                          }`,
                          color: msg.sender === "You" ? "white" : "white",
                          p: 1,
                          borderRadius: 2,
                          maxWidth: "70%",
                          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                          wordBreak: "break-word",
                        }}
                      >
                        <source  src={`data:audio/webm;base64,${msg.audioUrl}`} type="audio/webm" />
                        Your browser does not support the audio element.
                      </Box>
                     
                    ) : (
                      <>
                        <Box
                          component="audio"
                          controls
                          sx={{
                            border: `2px solid ${
                              msg.sender === "You" ? "#243B7F" : "#D85C26"
                            }`,
                            color: msg.sender === "You" ? "white" : "white",
                            p: 1,
                            borderRadius: 2,
                            maxWidth: "70%",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                            wordBreak: "break-word",
                          }}
                        >
                          <source
                            src={`data:audio/webm;base64,${msg.audioUrl}`}
                            type="audio/webm"
                          />
                          Your browser does not support the audio element.
                        </Box>
                        

                        <Box
                          sx={{
                            background:
                              msg.sender === "You"
                                ? "#243B7F"
                                : `linear-gradient(to right, #D85C26 ,#EA7437 ,#DA7527)`,
                            color: msg.sender === "You" ? "white" : "white",
                            p: 1,
                            borderRadius: 2,
                            maxWidth: "70%",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                            wordBreak: "break-word",
                            mt: 1,
                          }}
                        >
                          {/* Display msg.text if available */}
                          {msg.text && (
                            <Typography
                              variant="body1"
                              sx={{
                                fontFamily: "Gotham, sans-serif",
                                fontWeight: 200,

                                // width: "100%",
                              }}
                            >
                              {msg.text}
                            </Typography>
                          )}

                          {/* If msg.cleanedTextArray is available, render each line as separate Typography */}
                          {msg.cleanedTextArray &&
                            msg.cleanedTextArray.map(
                              (text: any, index: number) => (
                                <Typography
                                  key={index}
                                  variant="body1"
                                  sx={{
                                    fontFamily: "Gotham, sans-serif",
                                    fontWeight: 200,
                                    wordBreak: "break-word",
                                    width: "100%",
                                  }}
                                >
                                  {text}
                                </Typography>
                              )
                            )}

                          {/* If msg.Link is available, render as a clickable link */}
                          {msg.Link && (
                            <a
                              href={msg.Link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {msg.Link}
                            </a>
                          )}
                        </Box>
                      </>
                    )
                  ) : (
                    <Box
                      sx={{
                        background:
                          msg.sender === "You"
                            ? "#243B7F"
                            : `linear-gradient(to right, #D85C26 ,#EA7437 ,#DA7527)`,
                        color: msg.sender === "You" ? "white" : "white",
                        p: 1,
                        borderRadius: 2,
                        maxWidth: "70%",
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                        wordBreak: "break-word",
                      }}
                    >
                      {/* Display msg.text if available */}
                      {msg.text && (
                        <Typography
                          variant="body1"
                          sx={{
                            fontFamily: "Gotham, sans-serif",
                            fontWeight: 200,

                            // width: "100%",
                          }}
                        >
                          {msg.text}
                        </Typography>
                      )}

                      {/* If msg.cleanedTextArray is available, render each line as separate Typography */}
                      {msg.cleanedTextArray &&
                        msg.cleanedTextArray.map((text: any, index: number) => (
                          <Typography
                            key={index}
                            variant="body1"
                            sx={{
                              fontFamily: "Gotham, sans-serif",
                              fontWeight: 200,
                              wordBreak: "break-word",
                              width: "100%",
                            }}
                          >
                            {text}
                          </Typography>
                        ))}

                      {/* If msg.Link is available, render as a clickable link */}
                      {msg.Link && (
                        <a
                          href={msg.Link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {msg.Link}
                        </a>
                      )}
                    </Box>
                  )}

                  {msg.option && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 1,
                        mt: 1,
                      }}
                    >
                      {msg.option.map((opt, optIndex) => (
                        <Button
                          variant="outlined"
                          key={optIndex}
                          sx={{
                            background: "white",

                            fontFamily: "Gotham, sans-serif",
                            fontWeight: 700,
                            color: msg.sender === "You" ? "white" : "#243B7F",
                            borderRadius: 2,
                            p: 1,
                            minWidth: "120px",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                            textTransform: "none",
                          }}
                          onClick={() => handleSend(opt)}
                        >
                          {opt}
                        </Button>
                      ))}
                    </Box>
                  )}
                </Box>
              );
            })}

            <div ref={messagesEndRef} />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderTop: "1px solid #ccc",
              backgroundColor: "#F5F5F5",
              boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "0 0 8px 8px",
              padding: "8px", // Added padding to the box
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px", // Curved sides
                backgroundColor: "#243B7F",
                padding: "12px",
              }}
            >
              <IconButton
                onClick={
                  isRecording ? handleStopRecording : handleStartRecording
                }
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  backgroundColor: isRecording ? "#D85C26" : "inherit",
                  "&:hover": {
                    backgroundColor: isRecording ? "#D85C26" : "inherit",
                  },
                  borderRadius: "50%", // Circular shape
                  padding: "10px",
                }}
              >
                <MicIcon />
              </IconButton>
            </Box>
            <TextField
              variant="outlined"
              placeholder="Type your message..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSend(); // Call handleSend on "Enter" key press
                }
              }}
              sx={{ flex: 1, mr: 1, padding: "4px" }} // Added padding around TextField
              size="small"
            />
            <IconButton
              onClick={() => handleSend(inputValue)} // Call handleSend on button click
              sx={{
                backgroundColor: "#243B7F",
                color: "white",
                // "&:hover": { backgroundColor: "#10439F" },
                padding: "8px", // Added padding around SendIcon
              }}
            >
              <SendIcon />
            </IconButton>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default Chatbot;
